import angular from 'angular';

import tszUserSettings from './tsz-user-settings';

const tszUserSettingsModule = angular.module('tsz.components.tszUserSettings', [])
  .component('tszUserSettings', tszUserSettings);

export default tszUserSettingsModule;



// WEBPACK FOOTER //
// ./src/components/tsz-user-settings/tsz-user-settings.module.js